document.addEventListener("DOMContentLoaded", function () {
    let textarea = document.getElementById("custom-text");
    let hiddenInput = document.getElementById("custom-specification");

    console.log("textarea",textarea);
    // Update the hidden input value on textarea input
    textarea.addEventListener("input", function () {
        hiddenInput.value = textarea.value;
        console.log('textarea.value',textarea.value);
    });
});